import { PDFDocument } from 'pdf-lib'

import { convertDateString, createTable, savePdf } from '../../../../helpers/pdf'
import { IEventInterface } from '../../../../models/events/event.interface'

export const createOrderOfGoByClassPdf = async (
  event: IEventInterface,
  rows: { [key: string]: string[][] }
) => {
  // Create a new PDF document
  const pdfDoc = await PDFDocument.create()

  const headers = ['Rider • Coach', 'Horse • Trainer', 'Class', 'Ride Time']
  const colWidths = [20, 20, 40, 20] // in %

  const printedText = `^^By Class • Printed ${convertDateString(new Date(), 'tdm')}^^`
  const titleText = 'Order of Go'
  const urlText = 'www.thepegasus.app'

  for (const [index, key] of Object.keys(rows).entries()) {
    const displayText = key.split('<spacer>')[0].replaceAll('--', '')
    const textAboveTheFirstTable = `**${displayText}** • ${rows[key as any].length} rides`

    await createTable({
      pdfDoc,
      headers,
      rows: rows[key],
      colWidths,
      printedText: index === 0 ? printedText : undefined,
      titleText: index === 0 ? titleText : undefined,
      urlText: index === 0 ? urlText : undefined,
      textAboveTheFirstTable,
      currentPageNumber: index + 1,
      event,
    })
  }

  await savePdf(pdfDoc, `Event Reports - Order of Go by class - ${event?.eventName}.pdf`)
}
